(() => {
  if (window.driplockedCartSubmitBound) return;
  window.driplockedCartSubmitBound = true;
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.origin);
    if (!/\/cart\/add\/?$/.test(url.pathname)) return;
    event.preventDefault();
    if (pending.has(form)) return;
    const variant = form.querySelector('[name="id"]');
    const button = form.querySelector('[type="submit"]');
    if (!variant || variant.disabled || !variant.value || button?.disabled) return;
    const payload = new FormData(form);
    if(form.closest('[data-one-of-one]'))payload.set('quantity','1');
    const message = form.querySelector('[data-cart-error]') || form.querySelector('[data-node-type="commerce-add-to-cart-error"]');
    const disabledBefore = button.disabled;
    const fieldsets = [...form.querySelectorAll('fieldset')].map(el => [el, el.disabled]);
    pending.add(form);button.disabled = true;button.setAttribute('aria-busy', 'true');form.setAttribute('aria-busy', 'true');
    fieldsets.forEach(([el])=>el.disabled=true);
    if (message) { message.hidden = true; message.textContent = ''; }
    let added = false;
    try {
      url.pathname = url.pathname.replace(/\/$/,'') + '.js';
      const response = await fetch(url, { method:'POST', body:payload, headers:{Accept:'application/json'} });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || button.dataset.errorMessage);
      added = true;
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('cart:change',{detail:cart}));
      window.DriplockedEditorial?.closeMenu(false);
      if (window.openCartDrawer) window.openCartDrawer();
      else location.assign(`${root}cart`);
    } catch (error) {
      if (message) {
        message.hidden = false;message.style.display = '';
        message.textContent = added ? (window.dlCartMessages?.refresh || 'Item added. Open the cart page to check your cart.') : error.message || button.dataset.errorMessage || 'Unable to update your cart. Please try again.';
      }
      console.error('Cart request failed:', error);
    } finally {
      pending.delete(form);form.removeAttribute('aria-busy');button.removeAttribute('aria-busy');
      button.disabled = button.dataset.available ? button.dataset.available !== 'true' : disabledBefore;
      fieldsets.forEach(([el,disabled])=>el.disabled=disabled);
    }
  });
})();
